export default "__VITE_ASSET__2d0d66b6__"